import { motion } from "framer-motion";
import { Target, Handshake, RefreshCw } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

export function FractionalSection() {
  const { t } = useLanguage();

  const points = [
    {
      icon: Target,
      title: t("fractional.point.1.title"),
      description: t("fractional.point.1.description"),
    },
    {
      icon: Handshake,
      title: t("fractional.point.2.title"),
      description: t("fractional.point.2.description"),
    },
    {
      icon: RefreshCw,
      title: t("fractional.point.3.title"),
      description: t("fractional.point.3.description"),
    },
  ];

  return (
    <section className="py-20 lg:py-32">
      <div className="section-container">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              {t("fractional.title")}{" "}
              <span className="text-primary">{t("fractional.symbol")}</span>{" "}
              {t("fractional.titleEnd")}
            </h2>
            <p className="text-xl text-muted-foreground mb-4">
              {t("fractional.subtitle")}
            </p>
            <p className="text-xl text-primary font-semibold">
              {t("fractional.subtitleHighlight")}
            </p>
          </motion.div>

          {/* Right content - cards */}
          <div className="space-y-4">
            {points.map((point, index) => (
              <motion.div
                key={point.title}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="card-surface p-5 flex items-start gap-4 hover-lift"
              >
                <div className="icon-box-sm shrink-0">
                  <point.icon className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    {point.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {point.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Data callout */}
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="mt-12 text-sm text-muted-foreground/70 text-center max-w-3xl mx-auto italic"
        >
          {t("fractional.dataCallout")}
        </motion.p>
      </div>
    </section>
  );
}
